import { TextareaAutosize } from '@mui/material';
import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import DeviceView from '../Uswitch/deviceview'
import TableRow from '@mui/material/TableRow';

export default function Rack(given) {
    console.log('rack given' , JSON.stringify(given));
    var switch_io = given?.switch_now.ucs.allthings;
    console.log('in rack..switch_io:',switch_io);
    var thinglist = switch_io;
    var subscribe_list = []
    var device_list = []


    // TRIM THE LIST DOWN FOR NOW TO JUST 2 DEVICES
    thinglist?.forEach( thisThing => {
      var thingName = thisThing.thingName;
      if ( thingName === "4091511c51cd")  {
      //  if (thingName === "4091511c44dd" || thingName === "4091511c51cd") {
        device_list.push(thisThing.thingName);
      }
    });
    console.log('the things list',subscribe_list);
    const device_list_keys = Object.keys(switch_io);
    console.log('RACK DEVICES TO RENDER LIST ', device_list);

    return (
        <>
            {device_list?.map((this_device) => (           
                <DeviceView title={"Device." + this_device} device={this_device}  />
            ))}        
        </>
    );

}
